import clsx from "clsx";
import { useStoryViewedPageViewAnalytics } from "@/libs/analytics/analyticsHooks";
import { TextLink } from "@/src/components/links/components/TextLink";
import { Body5 } from "@/src/components/typography/components/Body";
import { Label4 } from "@/src/components/typography/components/Label";
import { Legal2 } from "@/src/components/typography/components/Legal";
import { useProductData } from "@/src/hooks/useProductData";
import RichTextRenderer from "../../RichTextRenderer";
import { BodyName } from "../../typography/components/Body/types";
import { TabProps } from "../types";
import { Title } from "./TabTitle";
import CocreatedWith from "./CocreatedWith";

const StoryTab: React.FC<TabProps> = ({ productName }) => {
  const { productData } = useProductData(productName as string);
  useStoryViewedPageViewAnalytics();
  const storyTabData = productData?.tabs?.storyTab;

  if (!storyTabData) {
    return null;
  }

  const {
    leftDescriptionTitle,
    leftDescriptionText,
    leftDescriptionSmallText,
    rightDescriptionTitle,
    rightDescriptionText,
    rightDescriptionUrl,
    coCreatedWith,
  } = storyTabData;

  return (
    <div className="flex flex-col desktop:flex-row gap-8 desktop:gap-20 ">
      <div
        className={clsx(
          "mb-8 flex flex-col",
          rightDescriptionText ? "basis-2/3" : "basis-full",
        )}
      >
        {leftDescriptionTitle && <Title>{leftDescriptionTitle}</Title>}
        {leftDescriptionText && (
          <Body5 as="div" className="mb-5" md={BodyName.Body_4}>
            <RichTextRenderer richText={leftDescriptionText} />
          </Body5>
        )}
        {leftDescriptionSmallText && (
          <div>
            <Label4 className="mb-5">PURCHASE ELIGIBILITY</Label4>
            <Legal2 as="div" className="text-gray-350">
              {<RichTextRenderer richText={leftDescriptionSmallText} />}
            </Legal2>
          </div>
        )}
        {coCreatedWith && <CocreatedWith swooshHandles={coCreatedWith} />}
      </div>

      <div
        className={clsx(
          "desktop:basis-1/3 basis-full",
          !rightDescriptionTitle && !rightDescriptionText && "hidden",
        )}
      >
        {rightDescriptionTitle && <Title>{rightDescriptionTitle}</Title>}
        {rightDescriptionText && (
          <Body5 as="div" className="mb-5" md={BodyName.Body_4}>
            {<RichTextRenderer richText={rightDescriptionText} />}
          </Body5>
        )}
        {rightDescriptionUrl &&
          rightDescriptionUrl.url &&
          rightDescriptionUrl.text && (
            <Label4>
              <TextLink linkType="underlined" href={rightDescriptionUrl.url}>
                {rightDescriptionUrl.text}
              </TextLink>
            </Label4>
          )}
      </div>
    </div>
  );
};

export default StoryTab;
